import React, { PureComponent } from 'react';
import { Provider, connect } from 'unistore/react';
import { Flex, Box, ReflexProvider } from 'reflexbox';
import cx from 'classnames';

import { Store, Actions } from '../../Store';
import { startYearSelector } from '../../Selectors';
import Slider from '../Slider';
import ResultSeats from '../ResultSeats';
import ResultText from '../ResultText';
import EuropeMap from '../Maps/EuropeMap';
import GermanyMap from '../Maps/GermanyMap';
import ResultRegio from '../ResultRegio';
import BrexitToggle from '../BrexitToggle';
import ArticleTeaser from '../ArticleTeaser';
import BeforeElectionTeaser from '../BeforeElectionTeaser';
import AnalysisTeaser from '../AnalysisTeaser';

import './ElectionHub.styl';

const space = [ 0, 8, 16, 32, 64 ];
const breakpoints = [ 25, 48, 64 ];
const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

class ElectionHub extends PureComponent {
  constructor() {
    super();

    this.dynamicHeight = 0;
    this.teaserRef = React.createRef();
  }

  componentDidMount() {
    this.props.loadData();
  }

  getDynamicElementsHeight() {
    const seatsHeight = this.seatsRef.getBoundingClientRect().height;
    const textHeight = this.textRef.getBoundingClientRect().height;
    const brexitToggle = document.querySelector('.brexit-toggle');
    let brexitToggleHeight = 0;

    if (brexitToggle) {
      brexitToggleHeight = brexitToggle.getBoundingClientRect().height;
    }

    return seatsHeight + textHeight + brexitToggleHeight;
  }

  mapVisible() {
    return this.mapRef.getBoundingClientRect().top < (window.innerHeight);
  }

  componentWillReceiveProps(nextProps) {
    if (isIos && this.mapVisible() && nextProps.dataIndex !== this.props.dataIndex) {
      this.scrollPos = window.pageYOffset || document.documentElement.scrollTop;
      this.dynamicHeight = this.getDynamicElementsHeight();
    }
  }

  componentDidUpdate(prevProps) {
    if (isIos && this.mapVisible() && prevProps.dataIndex !== this.props.dataIndex) {
      const heightOffset = this.getDynamicElementsHeight() - this.dynamicHeight;
      const nextScrollPos = this.scrollPos + heightOffset;

      window.scrollTo({ top: nextScrollPos });
    }
  }

  getHeadline() {
    const { startYear, isBeforeElection } = this.props;

    if (!isBeforeElection) {
      return `Europawahl ${startYear}`;
    }

    return startYear === 2019 ? 'Vor der Wahl 2019' : `Europawahl ${startYear}`;
  }

  render() {
    const { startYear, isBeforeElection } = this.props;
    const wrapperClassNames = cx('eu2019-hub');
    const mapWrapperClasses = cx('mapwrapper result-maps', { 'is-inactive': isBeforeElection && startYear === 2019 });

    return (
      <ReflexProvider
        space={space}
        breakpoints={breakpoints}
      >
        <div className={wrapperClassNames}>
          <Slider />
          <div className="eu2019-hub-wrapper">
            <div className="eu2019-hub-header">
              <div className="eu2019-hub-headline">{this.getHeadline()}</div>
            </div>
            {!isBeforeElection && startYear === 2019 && <BrexitToggle />}
            <Flex wrap className="eu2019-results">
              <Box className="eu2019-results-first">
                <ResultSeats seatsRef={(ref) => { this.seatsRef = ref; }} />
              </Box>
              <Box className="eu2019-results-second">
                {/* <AnalysisTeaser /> */}
                <ResultText textRef={(ref) => { this.textRef = ref; }} />
                <Flex wrap className={mapWrapperClasses}>
                    <EuropeMap mapRef={(ref) => { this.mapRef = ref; }} />
                    <GermanyMap/>
                  {isBeforeElection && startYear === 2019 && (
                    <div ref={this.teaserRef}>
                      <Box w={1} >
                        <BeforeElectionTeaser />
                      </Box>
                    </div>
                  )}
                </Flex>
                <ResultRegio />
              </Box>
            </Flex>
          </div>
          {!isBeforeElection && <ArticleTeaser {...ARTICLE_CONFIG.teaser_regio} />} 
          {!isBeforeElection && <ArticleTeaser {...ARTICLE_CONFIG.teaser} />}
        </div>
      </ReflexProvider>
    );
  }
};

const ElectionHubConnected = connect(state => ({
  startYear: startYearSelector(state),
  dataIndex: state.dataIndex,
  isBeforeElection: state.isBeforeElection,
}), Actions)(ElectionHub);

export default () => (
  <Provider store={Store}>
    <ElectionHubConnected />
  </Provider>
);
